const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1"]);

function buildAllowedHosts(): Set<string> {
  const hosts = new Set<string>();
  const envList = process.env.REACT_APP_GATE_RETURN_URL_ALLOWED_HOSTS ?? "";
  for (const part of envList.split(",")) {
    const h = part.trim().toLowerCase();
    if (h) hosts.add(h);
  }
  try {
    const dash = process.env.REACT_APP_GATE_DASHBOARD_URL;
    if (dash) hosts.add(new URL(dash).hostname.toLowerCase());
  } catch {
    /* ignore */
  }
  if (hosts.size === 0) {
    hosts.add("gate.academyhi5.com");
    hosts.add("hi5gate.furkaneryilmaz.com");
    hosts.add("localhost");
    hosts.add("127.0.0.1");
  }
  return hosts;
}

export function sanitizeGateReturnUrl(returnUrl: string | null | undefined): string | null {
  const trimmed = (returnUrl ?? "").trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }

  if (parsed.username || parsed.password) return null;
  const protocol = parsed.protocol.toLowerCase();
  if (protocol !== "http:" && protocol !== "https:") return null;

  const host = parsed.hostname.toLowerCase();
  if (!buildAllowedHosts().has(host)) return null;

  const production = process.env.NODE_ENV === "production";
  const local = LOCAL_DEV_HOSTS.has(host);

  if (production && (protocol !== "https:" || local)) return null;
  if (!production && local && protocol === "http:") return parsed.toString();
  if (protocol !== "https:" && !local) return null;

  return parsed.toString();
}
